import * as React from 'react'
import { Button } from 'primereact/button'
import DialogCustom, { DialogProps } from 'app/shared/components/Dialog'
import { AcntList } from 'app/core/models/api/dep/dep0103'
import { convertAccountFormat } from '../utils/comUtil'
import Icon from './Icon'

/**
 * 계좌 리스트 데이터 외 다른 것을 사용하는 것을 대비해 제네릭으로 변환,
 * TODO: 일단은 AcntList를 그대로 사용한다. 외부 참조는 좋지 않으므로 추후 내장 시킨다.
 */
export type DialogAccountItem<T = Partial<AcntList>> = T & {
    /**
     * 선택된 계좌 여부, 설정할 때에도 사용한다.
     */
    selected?: boolean
}
export type DialogAccountProps<T = AcntList> = Partial<DialogProps> & {
    /**
     * 아이템 선택 콜백, (주의) selectedItem과 items는 각각 prop items의 복제본이므로 selectedItem과 items안에 선택된 item은 서로 동일한 오브젝트가 아니다.
     * @param selectedItem - 선택한 아이템. selected = true를 채워서 리턴
     * @param items - props에 전달한 items를 복제하여 selected = true/false를 추가해 전달
     */
    onSelect?(
        selectedItem: DialogAccountItem<T>,
        items: DialogAccountItem<T>[]
    ): void
    /** 변경될때만 트리거 */
    onChange?(
        selectedItem: DialogAccountItem<T>,
        items: DialogAccountItem<T>[]
    ): void
    /**
     * 화면에 표시될 목록 데이터. 별도 지정이 없는 경우 AcnList 타입을 사용.
     */
    items?: DialogAccountItem<T>[]
    /**
     * DialogAccountItem&lt;T&gt;에 별도 타입을 사용하는 경우, 타이틀 필드에 사용할 prop명
     */
    titleKey?: string
    /**
     * DialogAccountItem&lt;T&gt;에 별도 타입을 사용하는 경우, 서브 타이틀 필드에 사용할 prop명
     */
    subTitleKey?: string
}
export const DialogAccount = <T,>({
    closeFocus,
    visible: propVisible,
    onSelect,
    onChange,
    onClose,
    items = [],
    titleKey = 'pdm',
    subTitleKey = 'acn',
}: DialogAccountProps<T>) => {
    const [visible, setVisible] = React.useState(propVisible)
    const handleAccountSelect = (selected: DialogAccountItem<T>) => {
        const rtItems = []
        const rtSelected = { ...selected, selected: true }
        items.forEach((item) => {
            const rtItem = { ...item }
            rtItem['selected'] = item === selected //두 개가 같은 레퍼런스면...
            rtItems.push(rtItem)
        })
        if (items.find((x) => x.selected)?.['acn'] !== selected['acn']) {
            onChange?.(rtSelected, rtItems)
        }
        onSelect?.(rtSelected, rtItems)
        setVisible(false)
        onClose?.()
    }

    React.useEffect(() => {
        setVisible(propVisible)
    }, [propVisible])

    return (
        <DialogCustom
            closeFocus={closeFocus ? closeFocus : 'ibkSelectButton'}
            visible={visible}
            header={titleKey == 'copnPtrnNm' ? '쿠폰선택' : 'IBK 계좌선택'}
            className="bottom-sheet"
            onClose={() => {
                setVisible(false)
                onClose?.()
            }}
        >
            <div className="radiobuttons-bank">
                {items.map((item, index) => (
                    <Button
                        onClick={() => {
                            handleAccountSelect(item)
                        }}
                        className={`selectbutton ${
                            item.selected && 'selection'
                        }`}
                        key={`accounts${index}`}
                    >
                        <Icon name="bank14" text="IBK" />
                        <span className="txbox">
                            <span className="name">
								{subTitleKey === 'acn' && item[titleKey]}</span>
                            <strong className="number">
                                {subTitleKey === 'acn'
                                    ? convertAccountFormat(item[subTitleKey])
                                    : item[subTitleKey]}
                            </strong>
                        </span>
                    </Button>
                ))}
            </div>
        </DialogCustom>
    )
}
